<template>
  <div :style="`min-height: ${screenHeight}px`" id="GridParent">
    <v-list dense flat two-line v-if="setting">
      <!-- item-active-class white--text -->
      <v-list-item-group v-model="agenda_numbering" mandatory color="primary">
        <v-list-item
          v-for="(setting, i) in setting.columns"
          :key="`list-item-numbering${i}`"
          :value="setting.value"
        >
          <v-list-item-action>
            <v-radio
              :off-icon="
                agenda_numbering === setting.value ? '$radioOn' : '$radioOff'
              "
            />
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="subtitle-2">
              {{ $t(`admin.${setting.label}`) }}
            </v-list-item-title>
            <v-list-item-subtitle>{{
              $t(`admin.${setting.caption}`)
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <v-list dense flat two-line v-if="false">
      <v-list-item-group v-model="agenda_numbering" active-class="primary">
        <v-list-item>
          <template v-slot:default="{ active }">
            <v-list-item-action>
              <v-radio :input-value="active" value="hi"></v-radio>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title
                >Sequential Number throughout Meeting</v-list-item-title
              >
              <v-list-item-subtitle
                >Sequential Number which is unique throughout a meeting is
                assigned.</v-list-item-subtitle
              >
            </v-list-item-content>
          </template>
        </v-list-item>
        <v-list-item>
          <template v-slot:default="{ active }">
            <v-list-item-action>
              <v-radio :input-value="active" value="hi"></v-radio>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title
                >Sequential Number within topic category</v-list-item-title
              >
              <v-list-item-subtitle
                >Sequential Number which is unique within Topic category is
                assigned</v-list-item-subtitle
              >
            </v-list-item-content>
          </template>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <confirm-dialog ref="confirm" />
    <message-sheet
      :showMessage="displayMessage"
      :message="message"
      :messageType="messageType"
      @close="displayMessage = false"
    ></message-sheet>
  </div>
</template>
<style scoped>
.white--text /deep/ .v-list-item__subtitle {
  color: #fff !important;
}
</style>
<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import ConfirmDialog from "../ConfirmDialog.vue";
import Loader from "@/components/Loader";
import MessageSheet from "../MessageSheet.vue";
import { createUUID } from "/src/utils/util";
import _ from "lodash";
import { L10n } from "@syncfusion/ej2-base";
import * as localeText from "@/Langs/locale.json";
L10n.load(localeText.default);

Vue.prototype.$eventHub = new Vue();

export default {
  components: {
    ConfirmDialog,
    Loader,
    MessageSheet,
  },
  name: "AgendaNumbering",
  props: {
    screenHeight: {
      type: Number,
      default: 250,
    },
    setting: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isDirty: this.isChangePrevent,
      displayMessage: false,
      messageType: "",
      message: "",
      Loaderloading: true,
      agenda_numbering: "",
      default_setting: "",
      data: [],
    };
  },
  computed: {
    ...mapGetters({
      tenantSettingConfig: "tenant/tenantSettingConfig",
      tenantSettingTypes: "tenant/tenantSettingTypes",
      masterSettingTypes: "tenant/masterSettingTypes",
    }),
    LoaderText() {
      return this.$t("LoaderText");
    },
    tenantId() {
      return localStorage.getItem("tenantId");
    },
    locale() {
      return this.$i18n.locale;
    },
  },
  async created() {
    try {
      this.configurations = await this.masterSettingTypes("settings");
      this.Loaderloading = false;
    } catch (error) {
      this.Loaderloading = false;
    }
  },
  mounted() {
    this.setConfig();
  },
  watch: {
    async agenda_numbering(value) {
      if (value !== this.default_setting) {
        await this.updateConfiguration();
      }
    },
  },
  methods: {
    ...mapActions({
      updateTenantConfig: "tenant/updateTenantConfig",
      createTenantConfig: "tenant/createTenantConfig",
    }),
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
    async setConfig() {
      const config = this.setting;
      if (config) {
        await this.onTenantConfigNameChange(config);
      }
    },

    async onTenantConfigNameChange(config) {
      try {
        this.default_setting = config.columns[0].value;
        const results = this.tenantSettingTypes(config.configname);
        if (results.length == 0) {
          this.agenda_numbering = config.columns[0].value;
        } else {
          this.default_setting = results;
          this.agenda_numbering = results;
        }
        this.Loaderloading = false;
      } catch (error) {
        this.Loaderloading = false;
      }
    },

    async updateConfiguration() {
      try {
        const tenantConfig = this.tenantSettingConfig(this.setting.configname);
        this.default_setting = this.agenda_numbering;
        if (tenantConfig && tenantConfig.id) {
          const setting = {
            id: tenantConfig.id,
            tenantid: tenantConfig.tenantid,
            configname: tenantConfig.configname,
            [this.setting.configname]: this.agenda_numbering,
          };
          this.Loaderloading = true;
          await this.updateTenantConfig(setting);
          this.Loaderloading = false;
          this.displayMessage = true;
          this.messageType = "success";
          this.message = this.$t("admin.updateTenantConfigMsg");
        } else {
          const setting = {
            id: createUUID(),
            tenantid: this.tenantId,
            configname: this.setting.configname,
            [this.setting.configname]: this.agenda_numbering,
          };
          this.createTenantConfig(setting);
          this.displayMessage = true;
          this.messageType = "success";
          this.message = this.$t("admin.updateTenantConfigMsg");
        }
      } catch (error) {
        this.Loaderloading = false;
      }
    },
  },
};
</script>

<style scoped>
.item-active-class {
  background: #006cad !important;
  color: #ffffff !important;
  font-weight: 700 !important;
}
::v-deep .e-grid .e-tooltip-wrap.e-griderror {
  z-index: 10 !important;
}
::v-deep .e-grid .e-gridheader {
  background-color: var(--v-appBar-darken1);
  border-bottom-color: #e0e0e0;
  border-top-color: #e0e0e0;
  color: rgba(0, 0, 0, 0.54);
}
::v-deep .e-grid .e-rowcell {
  padding-right: 8px !important;
}
::v-deep .e-grid .e-headercell,
.e-grid .e-detailheadercell {
  /* color: var(--v-secondary-darken1);
  background-color: var(--v-appBar-darken1);
  border-bottom: 2px solid var(--v-appBar-darken2) !important;
  height: 32px !important; */
  font-family: "Noto Sans JP" !important;
  font-style: normal !important;
  background: var(--v-neutralGray-base) !important;
  color: #ffffff !important;
  height: 32px !important;
  min-height: 32px !important;
}

::v-deep .e-grid .e-headercelldiv {
  font-weight: bold;
  font-size: 12px;
}
::v-deep .e-toolbar.e-control {
  box-sizing: content-box;
  background-color: var(--v-appBar-base) !important;
  border-color: var(--v-pageHeader-base) !important;
  color: #ffffff;
  display: grid !important;
}

::v-deep .v-card__text {
  width: 100%;
  padding: 12px !important;
}

::v-deep .e-grid .e-toolbar-items {
  /* background-color: inherit; */
  height: 48px !important;
  min-height: 48px !important;
}
.e-grid .e-toolbar-items {
  background-color: #fff;
}

::v-deep .e-toolbar .e-toolbar-items .e-toolbar-item {
  align-content: center;
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  min-height: 40px !important;
  vertical-align: middle;
  width: auto;
}
::v-deep .e-toolbar .e-tbar-btn.e-btn {
  font-family: "Noto Sans JP" !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  background-color: var(--v-primaryDark-base) !important;
  border-color: var(--v-primaryDark-base) !important;
  min-width: 64px !important;
  padding: 0 16px 0 10px !important;
  color: #fff !important;
  align-items: center;
  border-radius: 4px;
  display: inline-flex;
  flex: 0 0 auto;
  justify-content: center;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}
::v-deep .e-toolbar .e-tbar-btn.e-btn .e-icons {
  color: #fff;
}
::v-deep .e-toolbar .e-overlay[aria-disabled="true"] .e-tbar-btn.e-btn {
  background-color: rgba(0, 0, 0, 0.12) !important;
}
::v-deep .e-toolbar .e-overlay[aria-disabled="true"] .e-icons,
::v-deep .e-toolbar .e-overlay[aria-disabled="true"] .e-tbar-btn-text {
  color: rgba(0, 0, 0, 2.26) !important;
}
::v-deep .e-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn-text {
  color: #fff;
}
::v-deep .e-toolbar .e-toolbar-items .e-toolbar-item.e-overlay {
  background: inherit;
}

::v-deep .e-splitter .e-split-bar.e-split-bar-horizontal {
  background: var(--v-pageHeader-lighten2);
  z-index: 1 !important;
  width: 1px !important;
  margin-left: 1px;
  margin-right: 1px;
}
.splitterContent
  /deep/
  .e-split-bar.e-split-bar-horizontal.e-resizable-split-bar::after {
  width: 4px !important;
}
/* split bar color in hover and active state */
::v-deep .e-splitter .e-split-bar.e-split-bar-horizontal.e-split-bar-hover,
.e-splitter .e-split-bar.e-split-bar-horizontal.e-split-bar-active {
  background: var(--v-pageHeader-base);
}

/* default split bar resize handle color */
::v-deep .e-splitter .e-split-bar.e-split-bar-horizontal .e-resize-handler {
  color: var(--v-pageHeader-base);
}

/* default split bar resize handle color in hover and active state */
::v-deep
  .e-splitter
  .e-split-bar.e-split-bar-horizontal.e-split-bar-hover
  .e-resize-handler,
.e-splitter
  .e-split-bar.e-split-bar-horizontal.e-split-bar-active
  .e-resize-handler {
  color: var(--v-pageHeader-base);
}

/* split bar arrows - circular border */
::v-deep
  .e-splitter
  .e-split-bar.e-split-bar-horizontal.e-split-bar-hover
  .e-navigate-arrow.e-arrow-left {
  background-color: var(--v-pageHeader-lighten2) !important;
  opacity: initial;
}

::v-deep
  .e-splitter
  .e-split-bar.e-split-bar-horizontal.e-split-bar-hover
  .e-navigate-arrow.e-arrow-right {
  background-color: var(--v-pageHeader-lighten2) !important;
  opacity: initial;
}
/* split bar arrows */

::v-deep
  .e-splitter
  .e-split-bar.e-split-bar-horizontal
  .e-navigate-arrow.e-arrow-right {
  background-color: var(--v-pageHeader-lighten3) !important;
  opacity: 0.2;
}
</style>